<template>
  <div class="RealTimeView" >
    <a-modal :visible="visible" width="414px" top="8vh" :footer="null" :maskClosable="true" @cancel="visible = false" wrapClassName="sixgod">
      <iframe
        v-if="visible"
        id="iframe"
        class="screen"
        :scrolling="false"
        :src="url"
        @load="load"
      ></iframe>
    </a-modal>
  </div>
</template>

<script>
import { ref  } from 'vue';
export default {
  name: 'RealTimeView',
  props: {
    val:Object
  },
  setup(props) {
    const url = ref(process.env.VUE_APP_TRACEH5TEMPLATE + '?type=iframe')
    const visible = ref(false)
    const show = ()=>{
      // this.url = process.env.VUE_APP_TRACEH5TEMPLATE + '?type=iframe'
      visible.value = true
    }

    // 是否在加载中
    const loading = ref(true)

    // 加载完成事件
    const load = () => {
      loading.value = false
      document.getElementById('iframe').contentWindow.postMessage(props.val , process.env.VUE_APP_TRACEH5TEMPLATE );
    }

    return{
      loading,
      load,
      visible,
      show,
      url
    }
  }
}
</script>

<style lang="less" scoped>
.RealTimeView {
  .screen {
    border: 10px solid red;
    width: 414px /*no*/;
    height: 667px /*no*/;
    border: 0;

    // 隐藏滚动条
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
  }
}

</style>
<style >
.sixgod .ant-modal-body{
  padding: 0px;
}
.sixgod iframe{
  width: 414px /*no*/;
  height: 667px /*no*/;
}
</style>